//------------------------------------------
// create new character campaign note entry
//------------------------------------------
export default function createNewCharacterCampaignNoteEntry({
  id, // temp id used for tracking
  updated_at, // timestamp of last update
  note, // content of the campaign note
  session_date = '',
  character = null,
} = {}) {
  console.log('---------------------------------------------')
  console.log('IN createNewCharacterCampaignNoteEntry')

  let character_id = null
  if (character && typeof character === 'object') {
    character_id = character.id
  }
  //------------------
  // define structure
  //------------------
  let campaign_note = {
    ...(character ? { character: character_id } : {}),
    id: id, // temp id used for tracking
    updated_at: updated_at,
    note: note,
    session_date,
  }
  return campaign_note
}
